import { createFileRoute } from "@tanstack/react-router";
import SqlBuilderPage from "@/pages/SqlBuilderPage";

export const Route = createFileRoute("/tools/sql-builder")({
  component: SqlBuilderPage,
});
